import { useUpdateInvoice } from "@/api/invoice";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { InvoiceStatusEnum } from "@/constants/enums/invoiceStatus.enum";
import { Loader2, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

type ModalProps = {
  closeModal: () => void;
  id: string | null;
};

export const RestoreInvoiceModal = ({ closeModal, id }: ModalProps) => {
  const { t } = useTranslation(["boInvoices", "common"]);
  const { mutateAsync: updateInvoice, isPending } = useUpdateInvoice();

  const handleRestoreInvoice = async () => {
    if (!id) return;
    await updateInvoice({ id, data: { status: InvoiceStatusEnum.PENDING } });
    closeModal();
  };

  return (
    <Modal
      open={!!id}
      onClose={closeModal}
      dismissible
      size="sm"
      title={
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-full bg-green-100">
            <RotateCcw className="size-5 text-green-600" />
          </div>
          <span>{t("restoreModal.title")}</span>
        </div>
      }
      description={t("restoreModal.description")}
      footer={
        <div className="flex w-full flex-col gap-2 md:flex-row">
          <Button onClick={handleRestoreInvoice} disabled={isPending} className="flex-1">
            {isPending ? <Loader2 className="animate-spin" /> : t("restoreModal.submit")}
          </Button>
          <Button variant="outline" onClick={closeModal} disabled={isPending} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
        </div>
      }
    />
  );
};
